import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { orpc } from "@/orpc/client";
import { PartnerAttributionsTable } from "./PartnerAttributionsTable";

interface PartnerAttributionsProps {
	partnerId: string;
}

export function PartnerAttributions({ partnerId }: PartnerAttributionsProps) {
	// Fetch attributions with infinite scroll
	const {
		data: attributionsData,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
	} = useSuspenseInfiniteQuery(
		orpc.partners.attributions.infiniteOptions({
			input: (pageParam) => ({
				partnerId,
				limit: 20,
				cursor: pageParam as string | undefined,
			}),
			initialPageParam: undefined as string | undefined,
			getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
		}),
	);

	return (
		<PartnerAttributionsTable
			data={attributionsData}
			hasNextPage={hasNextPage}
			isFetchingNextPage={isFetchingNextPage}
			fetchNextPage={fetchNextPage}
		/>
	);
}
